import { getSdk, SdkFunctionWrapper } from "@/codegen/graphql-request"
import * as Sentry from "@sentry/react"
import { ClientError, GraphQLClient } from "graphql-request"
import { redirectToLogin } from "./url"

export const gqlClient = () => {
	const client = new GraphQLClient(`${import.meta.env.VITE_APP_API_BASE_URL}/graphql`, {
		credentials: "include",
	})
	const errorResponseWrapper: SdkFunctionWrapper = async (action) => {
		try {
			return await action()
		} catch (error) {
			// ClientError以外の場合は、そのままthrow
			if (!(error instanceof ClientError)) {
				throw error
			}
			// ClientErrorの場合は、GraphQLエラー
			let message = "unknown_error"
			if (error.response.status == 200 && error.response.errors) {
				// HTTPステータスコードが200で、かつGraphQLエラーが発生した場合
				message = error.response.errors[0].message
			} else if (error.response.status == 400 && error.response.error) {
				// HTTPステータスコードが400で、かつAppエラーが発生した場合
				message = error.response.error
			} else if (error.response.status == 400 && error.response.data) {
				//  上記いずれのエラーではない場合
				message = error.response.data.error
			} else {
				console.debug(error)
			}
			if (message === "invalid_access_token" || message === "invalid_remote_ip") {
				localStorage.removeItem("email")
				const path = window.location.pathname
				location.href = redirectToLogin(path)
			} else {
				// "invalid_access_token" や "invalid_remote_ip" のような
				// リダイレクトすれば良いだけのエラーでは無い場合は、Sentryにエラーを送信する
				Sentry.captureException(error)
				alert(error.message)
			}

			// SdkFunctionWrapperが型エラーになるので、undefined as anyを返す
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			return undefined as any
		}
	}

	return getSdk(client, errorResponseWrapper)
}
